import EventOccurenceResourceModel from '../../generated/types/model/resource/EventOccurenceResourceModel';

export default class EventOccurenceResourceViewModel extends EventOccurenceResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
